import { gql, useQuery } from '@apollo/client'

const PROJECT_TECHNIQUE_LIST_QUERY = gql`
  query ProjectTechniqueList {
    projectTechniqueList {
      id
      name
    }
  }
`

export function useProjectTechniqueListQuery(options) {
  const { data, ...rest } = useQuery(PROJECT_TECHNIQUE_LIST_QUERY, options)

  return {
    data: data?.projectTechniqueList,
    ...rest
  }
}
